import React from 'react';
import { IonButton, useIonToast } from '@ionic/react';
import {
  Case,
  updatePatientInfo,
} from '../../../../services/buildfire/rdb/cases';
import PatientInfoForm from '../../../forms/PatientInfoForm';
import Bool from '../../../../constants/bool';
import styled from 'styled-components';
import useGoBackToCase from '../../../../hooks/useGoBackToCase';
import { getDatabase } from 'firebase/database';
import { useFirebase } from '../../../../services/firebase';
import CaseContext from '../../../../services/buildfire/rdb/CaseContext';

interface EditPatientProps {
  case: Case;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Content = styled.div`
  max-width: 600px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const EditPatient: React.FC<EditPatientProps> = ({ case: c }) => {
  const { app } = useFirebase();
  const [present] = useIonToast();
  const goBack = useGoBackToCase();
  const { updateCase: updateCaseLocally } = React.useContext(CaseContext);

  return (
    <Container>
      <Content>
        <PatientInfoForm
          case={c}
          title="Edit Patient Info"
          initialValues={{
            ...c,
            internalReferenceNumber: c.internalReferenceNumber || '',
            description: c.description || '',
            patientFirstName: c.patient.first || '',
            patientLastName: c.patient.last || '',
            fixed:
              c.fixed === undefined ? '' : c.fixed ? Bool.TRUE : Bool.FALSE,
          }}
          onSubmit={async (values) => {
            try {
              const db = getDatabase(app);
              const caseInfo = {
                patient: {
                  first: values.patientFirstName,
                  last: values.patientLastName,
                },
                internalReferenceNumber: values.internalReferenceNumber,
                fixed: values.fixed === Bool.TRUE,
                species: values.species,
                age: values.age,
                ageMonths: values.ageMonths,
                description: values.description,
              };
              await updatePatientInfo(db, c.id, caseInfo);

              updateCaseLocally({
                ...c,
                ...caseInfo,
              });
              goBack(c.id);
              present({
                message: 'Patient info updated successfully.',
                duration: 4000,
                position: 'bottom',
              });
            } catch (e) {
              console.error('Error updating patient info:', e);
              present({
                message: 'Error updating patient info, please try again.',
                duration: 6000,
                color: 'danger',
              });
            }
          }}
          renderButtons={({ disabled }) => (
            <ButtonContainer>
              <IonButton
                expand="block"
                disabled={disabled}
                fill="clear"
                onClick={() => goBack(c.id)}
              >
                Go back
              </IonButton>
              <IonButton
                expand="block"
                // buttonType="raised"
                type="submit"
                disabled={disabled}
              >
                Save Changes
              </IonButton>
            </ButtonContainer>
          )}
        />
      </Content>
    </Container>
  );
};

export default EditPatient;
